/* @flow */

export default class LostPasswordRequest {
  email: string;
}
